// Stateless components

export function ImportantNotice(props) {

    //
    // Render
    //
        
    return (
        <div className="alert__wrapper inner">
            <div className="alert alert--important">
                <div className="alert__icon" dangerouslySetInnerHTML={{__html: require('../../SVGs/html/warning-icon.html')}}>
                </div>
                <div className="alert__content">
                    <div className="alert__info">
                        {props.date && (
                            <span className="alert__date">{props.date}</span>
                        )}
                        {props.sender && (
                            <span className="alert__category">{props.sender}</span>
                        )}
                    </div>
                    <span className="alert__title">{props.title}</span>
                    <div className="alert__description" dangerouslySetInnerHTML={{__html: props.message}}>
                    </div>
                </div>
            </div>
        </div>
    );
    
};
